import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Logout = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Logout" {...props}>
    <path d="M8 1C8.55224 1.00003 8.99997 1.44776 9 2C9 2.55226 8.55226 2.99997 8 3H6C4.34317 3 3.00003 4.34317 3 6V18C3 19.6569 4.34315 21 6 21H8C8.55224 21 8.99997 21.4478 9 22C9 22.5523 8.55226 23 8 23H6C3.23858 23 1 20.7614 1 18V6C1.00003 3.2386 3.2386 1 6 1H8Z" fill="#000" /><path d="M16.293 6.29297C16.6835 5.90252 17.3165 5.90251 17.707 6.29297L22.707 11.293C23.0975 11.6835 23.0975 12.3165 22.707 12.707L17.707 17.707C17.3165 18.0975 16.6835 18.0975 16.293 17.707C15.9025 17.3165 15.9025 16.6835 16.293 16.293L19.5859 13H9C8.44776 12.9999 8 12.5523 8 12C8.00003 11.4478 8.44778 11.0001 9 11H19.5859L16.293 7.70703C15.9025 7.31652 15.9025 6.68348 16.293 6.29297Z" fill="#000" />
  </StyledIcon>
));

Logout.displayName = 'Logout';

export { Logout };
